module.exports = __webpack_public_path__ + "img/wx1.e72893fc.png";